module.exports = "/assets/dist/images/van_wide.jpg?d66a178d5cc4892bf22ed5d19a0ae39c";